import React from 'react';
import { useTranslation } from 'react-i18next';
import { DateService, NumberService } from 'Services';
import useGetReduxUsers from 'Hooks/reduxHelperHooks/useGetReduxUsers';
import useLatestDeploy from 'Hooks/query-hooks/useLatestDeploy';
import styles from './DeployedInfoText.css';

type DeployedInfoTextProps = {
    isLandlordDeployment: boolean;
};

const DeployedInfoText = ({ isLandlordDeployment }: DeployedInfoTextProps) => {
    const { t } = useTranslation();
    const { users } = useGetReduxUsers();
    const latestDeployAPI = useLatestDeploy(users);

    if (latestDeployAPI.isFetching || latestDeployAPI.isLoading || !latestDeployAPI.data || latestDeployAPI.isError) {
        return null;
    }

    const formattedDate = DateService.getDateTime(latestDeployAPI.data.createdAt) ?? latestDeployAPI.data.createdAt;
    const formattedRevision = NumberService.getLocaleNumber(latestDeployAPI.data.version);
    const text = t('deployedInfoText', {
        revision: formattedRevision,
        createdAt: formattedDate,
        createdBy: latestDeployAPI.data?._formatted?.createdBy
    });

    return (
        <span data-testid='deployed-info-text' className={styles.deployedInfoText}>
            {!isLandlordDeployment && text}
        </span>
    );
};

export default DeployedInfoText;
